import React, { useState } from "react"
import { FaTimes } from "react-icons/fa"

import { Modal, TextField } from "components"
import StrrdFooter from "./StrrdFooter"
import StrrdTableRow from "./StrrdTableRow"
import classes from "./index.module.scss"

const StrResolveDiscrepancyModal = (props) => {
  const {
    stockTransferRequest,
    setStockTransferRequests,
    showStockTransferResolveModal,
    setShowStockTransferResolveModal
  } = props

  const [resolveNote, setResolveNote] = useState("")
  const [resolvedItems, setResolvedItems] = useState([])

  const fillForm = () => {
    const receivedItems =
      stockTransferRequest.requestedItems
        .filter(requestedItem =>
          requestedItem.acceptedQuantity !== requestedItem.receivedQuantity
        )
        .map(requestedItem => ({
          foodId: requestedItem.foodId,
          optionId: requestedItem.optionId,
          foodImageCover: requestedItem.foodImageCover,
          foodName: requestedItem.foodName,
          foodOptionName: requestedItem.foodOptionName,
          isSimple: requestedItem.isSimple,
          unit: requestedItem.unit,
          requestedQuantity: requestedItem.requestedQuantity,
          acceptedQuantity: requestedItem.acceptedQuantity,
          receivedQuantity: requestedItem.receivedQuantity,
          returnedToDestinationQuantity: "",
          returnedToSourceQuantity: "",
          reductionFromSourceQuantity: "",
          lossQuantity: ""
        }))

    setResolvedItems(receivedItems)
  }

  const handleEnter = () => {
    fillForm()
  }

  return (
    <Modal
      
      size="xl"
      backdrop="static"
      onEnter={handleEnter}
      show={showStockTransferResolveModal}
      onHide={() => setShowStockTransferResolveModal(false)}
    >
      <div className={classes["container"]}>
        <div className={classes["header"]}>
          <button onClick={() => setShowStockTransferResolveModal(false)}>
            <FaTimes />
          </button>
        </div>

        <div className={classes["title"]}>
          گزارش مناقصه
        </div>

        <div className={classes["table-container"]}>
          <table className={classes["table"]}>
            <thead>
              <tr>
                <th style={{ width: "20%" }}>
                  نام کالا
                </th>
                <th style={{ textAlign: "center", width: "5%" }}>
                  مقدار درخواستی
                </th>
                <th style={{ textAlign: "center", width: "5%" }}>
                  مقدار قبول شده
                </th>
                <th style={{ textAlign: "center", width: "5%" }}>
                  مقدار دریافت شده
                </th>
                <th style={{ textAlign: "center", width: "10%" }}>
                  مقدار مرجوع شده
                </th>
                <th style={{ textAlign: "center", width: "10%" }}>
                  مقدار باز دریافت
                </th>
                <th style={{ textAlign: "center", width: "10%" }}>
                  مقدار کسری
                </th>
                <th style={{ textAlign: "center", width: "10%" }}>
                  مقدار ضایعات
                </th>
              </tr>
            </thead>
            <tbody>
              {resolvedItems.map(resolvedItem =>
                <StrrdTableRow
                  key={resolvedItem.optionId}
                  resolvedItem={resolvedItem}
                  setResolvedItems={setResolvedItems}
                />
              )}
            </tbody>
          </table >
        </div>

        <div className={classes["message"]}>
          <TextField
            componentClass="textarea"
            rows={4}
            label="یادداشت"
            maxLength={600}
            value={resolveNote}
            onChange={(e) => setResolveNote(e.target.value)}
          />
        </div>

        <StrrdFooter
          resolveNote={resolveNote}
          resolvedItems={resolvedItems}
          stockTransferRequest={stockTransferRequest}
          setStockTransferRequests={setStockTransferRequests}
          setShowStockTransferResolveModal={setShowStockTransferResolveModal}
        />
      </div>
    </Modal>
  )
}

export default StrResolveDiscrepancyModal